import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import AshdownSettingsHtml from './ashdown.settings.html';

export function AshdownStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'AshdownSettingsCtrl',
    name       : 'app.ashdown',
    templateUrl: AshdownSettingsHtml,
    url        : '/ashdown',
    resolve    : {
      session : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company')
    }
  });
}